<script setup lang="ts">
  import { MpText } from '@borg/ui';

  const { t } = useI18n();
  const jobsSearchStore = useJobsSearchStore();

  const searchResultsTitle = computed(() => {
    // Build title from deduplicated frontend data to avoid duplication issues
    const titleParts: string[] = [];

    // Add deduplicated positions
    if (jobsSearchStore.deduplicatedPositions.length > 0) {
      titleParts.push(...jobsSearchStore.deduplicatedPositions.map((pos) => pos.name));
    }

    // Add keywords (already deduplicated by nature)
    if (jobsSearchStore.filters.static.query.length > 0) {
      titleParts.push(...jobsSearchStore.filters.static.query);
    }

    // Add deduplicated locations
    if (jobsSearchStore.deduplicatedLocations.length > 0) {
      titleParts.push(...jobsSearchStore.deduplicatedLocations.map((loc) => loc.name));
    }

    if (titleParts.length > 0) {
      return titleParts.join(', ');
    }

    // Fallback to backend-generated title if no specific filters
    if (jobsSearchStore.searchItem?.title) {
      return jobsSearchStore.searchItem.title;
    }

    return t('SEARCH_PAGE.SEARCH_RESULT_LABEL');
  });

  const isLoading = computed(
    () => jobsSearchStore.loadState === 'inProgress' && jobsSearchStore.page === 1,
  );
</script>

<template>
  <MpText
    v-if="!isLoading"
    as="h1"
    type="h4"
    regular
    style="margin-top: var(--mp-space-90); margin-bottom: var(--mp-space-50)"
  >
    {{ searchResultsTitle }} <b>({{ jobsSearchStore.totalItems }})</b>
  </MpText>
</template>
